import {Component, HostListener} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';

import {ENUM, TAcessoFind, TAction, TFinanceSide, TLoginTipo, TPaymentFlag} from "../../../app/enum";
import {TGoogleAnalytic, Util} from "../../../app/util";
import {CONFIG} from "../../../app/config";
import {PaymentRepo} from '../../../repositories/payment-repo';
import {LogadoService} from '../../../providers/logado-service';
import {StorageService} from '../../../providers/storage-service';
import {PaybookMenuPage} from "../paybook-menu/paybook-menu";
import {EntrakiOpenPage} from "../entraki-open/entraki-open";
import {ProfileAuthPage} from '../profile-auth/profile-auth';
import {LancakiMenuPage} from '../lancaki-menu/lancaki-menu';

@Component({
    selector: 'page-machine-menu',
    templateUrl: 'machine-menu.html',
    providers: [PaymentRepo]
})
export class MachineMenuPage {
    
    ENUM: any = ENUM;
    config: any = CONFIG;

    TFinanceSide: any = TFinanceSide;

    etapa: number;

    comandas: any = [];
    elginpay: any = {load: false, hide: false, text: null, data: null, bool: false};
    showdetail: boolean = false;

    paymentPixe: boolean = true;
    paymentFail: any = null;
    prepagoCash: number;
    prepagoStep: number = 0;
    messageErro: string = null;
    timeoutTime: number = 0;
    timeoutMain: number;
    cancelaQtde: number = 0;
    cancelaTime: number = 0;

    akkjson = (window as any).handappMainInstance.appjson;
    monitorAuth = this.akkjson.hotwork;

    spotdays: any;

    writingTime: number = 0;
    warwriter: any;
    page00 = null;
    page01 = null;
    page02 = null;
    page03 = null;
    page04 = null;
    page05 = null;
    page06 = null;

    fade00 = false;
    fade02 = false;
    fade03 = false;
    fade04 = false;
    fade05 = false;
    fade06 = false;

    scannerData: string = '';
    @HostListener('window:keypress', ['$event'])
    keyEvent(event: KeyboardEvent) {
        this.barcodeRead(event);
    }

    constructor(public navParams: NavParams, public viewCtrl: ViewController, public util: Util,
                public navCtrl: NavController,
                public paymentRepo: PaymentRepo,
                public storageService: StorageService,
                public logadoService: LogadoService,
                ) {

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'TotemK2', '/totemK2-menu');

        this.etapa = 0;

        //** PAYMENT-FAIL: BACKUP DO PAGAMENTO QUE NAO GRAVOU NO DESK *//
        let onFail = (json) => {
            this.paymentFail = json;
            this.util.machineHard('ligarLedStatus', (json ? 'VERMELHO' : 'VERDE')).subscribe();
        }
        this.storageService.get('PAYMENT-FAIL').subscribe(json => onFail(json));

        // window.AndroidFullScreen.immersiveMode(successFunction, errorFunction);

        // function successFunction() {
        //   console.log("It worked!");
        // }
    
        // function errorFunction(error) {
        //     console.log(error);
        // }

        
        this.spotdayLoad();

    }

    writerNext(init) {

        let page = (this.page05 ? 6 : (this.page04 ? 5 : (this.page03 ? 4 : (this.page02 ? 3 : (this.page01 ? 2 : (this.page00 ? 1 : 0))))));
        let time;
        if (page == 0) time = 2000;
        if (page == 1) time = 5000;
        if (page == 2) time = 5000;
        if (page == 3) time = 5000;
        if (page == 4) time = 5000;
        if (page == 5) time = 5000;
        if (page == 6) time = 5000;

        let bool = (this.comandas.length == 0);
        let zera = (!bool || init || this.elginpay.data);

             if ( this.page01 && !this.fade00) { this.fade00 = true; this.fade02 = false; this.fade03 = false; this.fade04 = false; this.fade05 = false; this.fade06 = false; time = 1000; }
        else if ( this.page02 && !this.fade02) { this.fade02 = true; time = 5000; }
        else if ( this.page03 && !this.fade03) { this.fade03 = true; time = 5000; }
        else if ( this.page04 && !this.fade04) { this.fade04 = true; time = 5000; }
        else if ( this.page05 && !this.fade05) { this.fade05 = true; time = 1000; }
        else if ( this.page06 && !this.fade06) { this.fade06 = true; time = 1000; }

        else if ( this.page06 || zera) { this.page00 = null; this.page01 = null; this.page02 = null; this.page03 = null; this.page04 = null; this.page05 = null; this.page06 = null; this.fade00 = false; }

        else if (!this.page00 && bool)   this.page00 = {title: null, texto: null, warwriter: null, warning: '<b>HEY</b>, VOCÊ!', werning: null};
        else if (!this.page01 && bool)   this.page01 = {title: null, texto: null, warwriter: null, warning: '<b>OLHA</b>KI', werning: null};
        else if (!this.page02 && bool)   this.page02 = {title: null, texto: null, warwriter: null, warning: 'Quer pagar sua comanda?', werning: null};
        else if (!this.page03 && bool)   this.page03 = {title: null, texto: null, warwriter: null, warning: 'Seu <b>rolê</b>, Sem <b>fila</b>!', werning: null};
        else if (!this.page04 && bool)   this.page04 = {title: null, texto: null, warwriter: null, warning: '<b>OLHA</b>•PAY', werning: null};
        else if (!this.page05 && bool)   this.page05 = {title: null, texto: null, warwriter: null, warning: 'Entra, Curti, Paga e Vaza...', werning: null};
        else if (!this.page06 && bool)   this.page06 = {title: null, texto: null, warwriter: null, warning: '<b>Lorean</b> para <b>iOS</b> e <b>Android</b>', werning: null};

        //Stop-Loop para debugar tela!
        //if (this.page06 && true) return;

        clearTimeout(this.writingTime);
        this.writingTime = setTimeout(() => this.writerNext(false), time);

    }

   
    ionViewWillEnter() {

        this.writerNext(true);

    }

    ionViewDidEnter() {

        //ERRO VERIFICAR ACHO QUE ISSO SOBRE A BARRA DOS BOTOES DO ANDROID NO TOTEM! - Procurar por "display": (manifest.json)
        //this.util.stylesBarOnoff(false);
        //this.util.statusBarColor(TStatusBar.sbStyleLightContent);


        //REGISTER BARCODE SCANNER
        //window.addEventListener('keypress', this.barcodeRead);
        //window.document.addEventListener('keypress', this.barcodeRead);

    }

    ionViewDidLeave() {

        //REGISTER BARCODE SCANNER
        //window.removeEventListener('keypress', this.barcodeRead);
        //window.document.removeEventListener('keypress', this.barcodeRead);

    }
 
    //Hotkey - Ctrl+K
    comandaFake_EXCLUIR() {

      //this.comandaFind('9406', true);
        this.comandaFind('9999', true);

        // let onFinish = (data) => {
        //     if (data == null || data.Keylock.trim() == '') return;
        //     this.comandaFind(data.Keylock.trim(), true);
        // };

        // // ***** KEYLOCK YES ***** //
        // let buttons: Array<any> = [];
        // buttons.push({text: 'Cancelar', hole: 'cancel'});
        // buttons.push({text: 'Pronto', hole: null, handler: (data) => onFinish(data)});
        // let inputs = [{type: 'text', name: 'Keylock', placeholder: 'Keylock'}];
        // this.alertCtrl.create({title: 'Comanda', inputs: inputs, buttons: buttons}).present();

    }
    
    barcodeRead(e) {
        
        // Carregando TEF ou Tela de Retorno!
        if (this.elginpay.load || this.elginpay.hide || this.elginpay.data) return;

        if (e.key == 'Enter') {
            let scanerText = this.scannerData;
            scanerText = scanerText.replace('-', '').replace('-', '').replace('-', '').replace('-', '');
            scanerText = scanerText.replace('.', '').replace('.', '').replace('.', '').replace('.', '');

            this.scannerData = (ENUM.scannerRead(scanerText, this.monitorAuth.Hotspot.SettingBars)+'');
            this.comandaFind(this.scannerData, true);
            this.scannerData = '';
            return;
        }

        this.scannerData = this.scannerData + e.key;
      //this.scannerData = this.scannerData + String.fromCharCode(e.key);

    }
 
    statusbar() {

        //let color = (this.logado.Webstor ? 'CorDark' : this.akkjson.checkin.Branded.BrandedCora);
        //let style = this.util.stylesBarColor(color);
        //this.util.statusBarColor(style);

        let style = this.util.stylesBarColor('CorDark');
        this.util.statusBarColor(style);

    }

    spotdayLoad() {

        let hotspotID = this.monitorAuth.Hotspot.HotspotID;
        if (hotspotID == 1050) hotspotID = 999; //1349;

        //this.spotdayService.spotday(action, 0, hotspotID, profileID, projetoID)
        this.logadoService.started(TAction.acRole, null, '&HotspotID=' + hotspotID + '&ProfileID=' + 0 + '&ProjetoID=' + 0)
            .subscribe(data => {

                this.spotdays = data.Spotdays;

            }, erro => {

                //this.util.alertResult(erro);

            });

    }

    cancelaTela() {

        if (this.comandas.length) this.paymentDone(null, null);
        if (this.showdetail) this.timeoutNull();
        if (this.cancelaQtde >= 5) this.dismiss();
        
    }

    cancelaSoma() {

        this.cancelaQtde = this.cancelaQtde + 1;

        clearTimeout(this.cancelaTime);
        this.cancelaTime = setTimeout(() => this.cancelaQtde = 0, 5000);

    }

    entrakiExit() {

        let loading = this.util.loadingDots();
        loading.present();

        let hotspotID = this.monitorAuth.Hotspot.HotspotID;
        let params = '&ComandaID=' + this.akkjson.checkin.ComandaID;

        this.util.monitorDesk(false, 'DESK-Started', hotspotID, params, TAction.acExit)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {
                    
                    if (data.Comandas[0] && !data.Comandas[0].Outbook.OutbookBool) {
                        this.util.alertSimply('Efetue o pagamento no caixa!', data.Comandas[0].Outbook.OutbookText, 'OK, entendi', true);
                    }

                    if (data.Comandas[0] && data.Comandas[0].Outbook.OutbookBool) {
                        let paybook = this.akkjson.checkin;
                        let paycopy = this.util.deepCopy(paybook);
                        paycopy.Followe = {}; //#GAMBI - Para pedir avaliacao, certo deveria ter vindo da Bridge com os dados da ultima avaliacao.
    
                        let object = {etapa: 4, checkinSelf: true, hotspot: null, spotdayID: 0, paybook: paycopy, paybookTipo: paycopy.PaybookTipo, paybookModo: paycopy.PaybookModo};
                        this.util.modalopen(EntrakiOpenPage, 'quad', true, object).subscribe();
    
                        (window as any).handappMainInstance.checkinCall(0, false, hotspotID);
                    }

                },
                erro => this.util.alertResult(erro)
            );


        //#BRIDGE
        // let onExit = () => {
        //     let paybook = this.akkjson.checkin;
        //     let paycopy = this.util.deepCopy(paybook);

        //     if (!paybook.PaybookBora) {
        //         paybook.PaybookBora = this.util.dateToStr(null, true);
        //         paycopy.PaybookBora = this.util.dateToStr(null, true);
        //     }

        //     let object = {etapa: 4, hotspot: null, spotdayID: 0, paybook: paycopy, paybookTipo: paycopy.PaybookTipo, paybookModo: paycopy.PaybookModo};
        //     this.util.modalopen(EntrakiOpenPage, 'quad', true, object).subscribe();

        //     (window as any).handappMainInstance.checkinCall();
        // };

        // let loading = this.util.loadingDots();
        // loading.present();

        // this.hotspotService.paybook(TAction.acExit, this.akkjson.checkin.PaybookID)
        //     .finally(() => loading.dismiss())
        //     .subscribe(
        //         data => onExit(),
        //         erro => this.util.alertResult(erro)
        //     );

    }

    paybookCash(): number {

        let result = 0;

        if (this.comandas[0].PaybookPrey) return this.prepagoCash;

        this.comandas.forEach(PB => result = result + ENUM.paybookCash(PB, 'Deve'));
        return result;

    }

    paybookMenu(paybook) {

        // NÃO limpa comanda da tela
        this.timeoutZera(false);

        let object = {etapa: 0, olhaapp: false, monitorBool: true, fronter: false, profile: paybook.Profile, branded: paybook.Branded, workday: true, userset: null, paybookID: paybook.PaybookID, paybook: paybook};
        this.util.modalopen(PaybookMenuPage, 'alto', false, object)
            .finally(() => this.timeoutZera(true))
            .subscribe();

    }

    paybookTira(paybook) {

        let index = this.comandas.indexOf(paybook);
        this.comandas.splice(index, 1);

        if (this.comandas.length == 0) this.paymentDone(null, null);

    }

    paybookPush(paybook) {

        if (!paybook) return;

        this.prepagoStep = (paybook.PaybookPrey ? 2 : 0);

        let index = this.comandas.findIndex(PB => PB.PaybookID == paybook.PaybookID);
        if (index >= 0) this.util.clearObj(this.comandas[index], [], paybook);
        if (index < 0)  this.comandas.push(paybook);

        this.util.machineHard('ligarLedStatus', 'VERMELHO').subscribe();

    }

    tecladoCash() {

        this.prepagoStep = 1;

    }

    tecladoOkey(btn) {

        let paymentText = this.util.dinheiro(this.prepagoCash);
        paymentText = paymentText.replace('R$', '');
        paymentText = paymentText.replace(',',  '');
        paymentText = paymentText.replace('.',  '');
        paymentText = paymentText.replace(' ',  '');

        if (btn == 'ok') {

            this.prepagoStep = 0;
            
        }

        else if (btn == 'cancel') {
            this.dismiss();
        }

        else if (btn == 'erase') {
            if (paymentText.length) paymentText = paymentText.substring(0, paymentText.length-1);
        }

        else if (btn == 'left-thin') {
            if (paymentText.length) paymentText = paymentText.substring(0, paymentText.length-1);
        }

        else if (btn == 'dot') {
            //this.tecladoText = this.tecladoText + '.';
        }

        else {
            if (paymentText.length <= 10) paymentText = paymentText + btn;
        }

        paymentText = paymentText.substring(0, paymentText.length-2) + '.' + paymentText.substring(paymentText.length-2, 99);
        this.prepagoCash = parseFloat(paymentText);

    }

    lancakiMenu() {

        // NÃO limpa comanda da tela
        this.timeoutZera(false);

        let rootComanda = {Comandas: this.comandas};

        //#PREPAGO -> Escolhe valor por produtos
        let object = {etapa: 9, monitorBool: true, requestIpad: true, hotspotID: this.monitorAuth.Hotspot.HotspotID, rootComanda: rootComanda, comandaIN: 0, clusterIN: -1};
        this.util.modalopen(LancakiMenuPage, 'full', false, object)
        .subscribe(data => {
            this.prepagoCash = data.paymentItem;
            this.prepagoStep = (data.paymentItem ? 0 : 2);
            this.timeoutZera(true);
        });

    }


    comandaFind(comandaText, force, code?) {
        
        this.timeoutZera(true);

        if (!this.util.validaCNPF(comandaText) && !force) return;
        this.scannerData = '';

        let onPush = (data) => {

            let array = this.comandas;
            let comanda = (data.Comandas || [])[0];
            this.messageErro = null;

            if (!comanda) this.messageErro = 'Não encontrado';
            if (!this.messageErro && array[0] && comanda.PaybookPrey != array[0].PaybookPrey) this.messageErro = 'Pós vs Pré';
            if (!this.messageErro) {
                this.paybookPush(comanda);
                this.util.machineHard('ligarLedStatus', 'VERMELHO').subscribe();
            }

        };

        let onErro = (data) => this.messageErro = data.Result;
        
        let onDone = () => {
            loading.dismiss();
            this.timeoutZera(true);
        }

        let rnrn = this.util.validaCNPF(comandaText);
        let params = '&ComandaText=' + comandaText +
                     '&ComandaMode=' + (code ? TAcessoFind.afFindID : (rnrn ? TAcessoFind.afFindRnid : TAcessoFind.afFindNoro));

        let loading = this.util.loadingDots();
        loading.present();

        this.util.monitorDesk(true, 'DESK-Comanda', this.monitorAuth.Hotspot.HotspotID, params, TAction.acFind)
            .finally(() => onDone())
            .subscribe(
                data => onPush(data),
                erro => onErro(erro));

    }

    timeoutZera(runtime) {

        this.timeoutTime = 0;
        clearTimeout(this.timeoutMain);

        if (runtime && this.comandas.length) {
            this.timeoutTime = 30;
            this.timeoutMain = setInterval(() => {
                this.timeoutTime = this.timeoutTime - 1;
                if (this.timeoutTime <= 0) {
                    clearTimeout(this.timeoutMain);
                    this.paymentDone(null, null, true);
                }
            }, 1000);
        }

    }

    timeoutErro() {

        setTimeout(() => this.messageErro = null, 3000);

    }

    timeoutTela() {

        let onTime = () => {
            if (this.showdetail) return;
            this.elginpay.load = false;
            this.elginpay.hide = false;
            this.elginpay.text = null;
            this.elginpay.data = null;
            this.elginpay.bool = false;
            this.timeoutZera(true);
        }

        setTimeout(() => onTime(), 4000);

    }

    timeoutNull() {

        if (this.elginpay.load) return;

        let showdetail = this.showdetail;
        if (!showdetail) this.showdetail = true;
        if ( showdetail) {
            this.elginpay.text = null;
            this.elginpay.data = null;
            this.elginpay.bool = false;
            this.showdetail = false;
        }

    }

    paymentOkay(paymentSide, data) {

        let convert = !isNaN(data.extras.COMP_DADOS_CONF.valor);
        this.elginpay.load = false;
        this.elginpay.hide = true;
        this.elginpay.text = JSON.stringify(data);
        this.elginpay.data = this.util.deepCopy(data.extras);
        this.elginpay.bool = (this.elginpay.data && this.elginpay.data.CODRESP >= 0 && convert);

        if ( this.elginpay.bool) {
            this.util.machineHard('imprimir', this.elginpay.data.COMP_DADOS_CONF.viaCliente).finally(() => this.util.machineHard('acionarGuilhotina', '').subscribe()).subscribe();
            this.paymentMake(this.elginpay.data.COMP_DADOS_CONF, this.elginpay.data.CODRESP);
        }

        if (!this.elginpay.bool) {
            if (paymentSide == TFinanceSide.cdTodos && this.elginpay.data.CODRESP == -6) this.paymentPixe = false;
            this.timeoutTela();
        }

    }

    paymentErro() {

        //Construir paymentErro vs paymentOkay (rotina acima), ficar igual react-native

    }

    paymentSale(paymentSide) {

        // NÃO limpa comanda da tela
        this.timeoutZera(false);

        this.elginpay.load = true;
        this.elginpay.hide = false;
        this.elginpay.text = null;
        this.elginpay.data = null;
        this.elginpay.bool = false;
        let paymentCash = this.paybookCash();

        //Timeout é Respiro na tela so para aparecer icone "Iniciando"
        setTimeout(() => {
            //Timeout é Respiro na tela so para esconder icone "Iniciando" (na volta da tela)
            this.elginpay.hide = true;
            this.paymentRepo.paymentSale(paymentSide, paymentCash).subscribe(okay => this.paymentOkay(paymentSide, okay), erro => this.paymentOkay(paymentSide, erro))
        }, 3000);

    }

    //#GAMBI - MONITOR-DESK
    paymentMake(epay, code) {

        let comandas = [];
        this.comandas.forEach(CM => comandas.push({ComandaID: CM.ComandaID}));

        let payments = [];
        payments.push({
            MethodoID: 0,
            MethodoTX: (epay.rede == 'Shipay' ? 'Pix' : epay.administradora),
            AccountID: 0,
            GatewayID: 0,
            GatewayTX: epay.rede,
            PaymentFlag: TPaymentFlag.cpRealizado,
            PaymentSide: (epay.tipoCartao == 'Credito' ? TFinanceSide.cdCredito : TFinanceSide.cdDebito),
            PaymentCash: Number(epay.valor),
            PaymentPena: 0,
            PaymentJuro: 0,
            PaymentMore: 0,
            PaymentBack: 0,
            PaymentPago: epay.data,
            PaymentWill: epay.vencimento,
            PaymentDone: null,
            PaymentCode: code,
            PaymentCard: epay.numeroCartao,
            PaymentAuth: epay.autorizacao,
            PaymentNsun: epay.nsuRede || epay.nsu,
            PaymentArpe: '',
            PaymentPanu: '',
        });

        let json = {
            CashierID: 0,
            UsuarioID: 0,
            AssinarID: 0,
            Comandas: comandas,
            Payments: payments,
            PaymentEpay: epay,
        }

        this.paymentSend(json);

    }

    paymentSend(json, clearFail?) {

        let loading = this.util.loadingDots();
        loading.present();

        let hotspotID = this.monitorAuth.Hotspot.HotspotID;
        this.util.monitorDesk(true, 'DESK-Payment', hotspotID, '', TAction.acSave, json)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.paymentDone(null, null, clearFail),
                erro => this.paymentDone(json, erro),
            );

    }

    paymentDone(json, erro, clearFail?) {

        this.comandas = [];
        this.timeoutTime = 0;
        this.prepagoStep = 0;
        this.prepagoCash = 0;

        if (erro) this.messageErro = erro.Result;

        // Tentativa de processar novamente! com sucesso!
        if (!json && clearFail) {
            this.paymentFail = null;
            this.storageService.set('PAYMENT-FAIL', null).subscribe();
        }

        // Finaliza Tela
        this.timeoutTela();


        this.util.machineHard('ligarLedStatus', (json ? 'VERMELHO' : 'VERDE')).subscribe();
        
        
        // Sucesso
        if (!json) return;

        this.paymentFail = json;
        this.storageService.set('PAYMENT-FAIL', json).subscribe();

    }

    paymentRead(object) {

        return this.util.jsLoop(object);

    } 

    showparse() {

        return JSON.stringify(this.elginpay.data);

    }

    usuarioAuth(acao: 'Payment-Lixo') {

        /** 5 - PASSWORD **/
        let object = {etapa: 0, rootile: null, loginTipo: TLoginTipo.loPassword, justLogin: true};
        this.util.modalopen(ProfileAuthPage, 'alto', false, object).subscribe(
            data => {
                if (this.logadoService.getAuth()) {
                    this.logadoService.logout(); //#EXCLUIR - Nao era para fazer login, somente buscar usuario, excluir e arrumar na janela ProfileAuthPage
                    if (acao == 'Payment-Lixo' && data.UsuarioEsto) this.paymentDone(null, null, true);
                }
            }
        );

    }


    dismiss() {

        this.util.machineHard('desligarLedStatus', '').subscribe();

        let animation = {animation: 'md-transition'};
        this.navCtrl.pop(animation);

    }


}




// WEBPACK FOOTER //
// ./src/pages/sync/machine-menu/machine-menu.ts